import { KeyboardArrowDown } from "@mui/icons-material";
import { Button, Popover } from "@mui/material";
import { useAppSelector } from "redux/hooks";
import { selectCase } from "redux/slices/case/";
import CaseSummary from "./Summary";
import { usePopover } from "helpers/hooks/usePopover";

export default function ButtonSummary() {
  const lensCase = useAppSelector(selectCase);
  const popover = usePopover();

  return (
    <>
      <Popover
        open={popover.isOpen}
        onClose={popover.onPopoverClose}
        anchorEl={popover.anchorEl}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}>
        <div className="w-[730px]">
          <CaseSummary mycase={lensCase} onClose={popover.onPopoverClose} />
        </div>
      </Popover>
      <Button
        color="default"
        endIcon={<KeyboardArrowDown />}
        className="mr-4"
        onClick={(event) => popover.onPopoverOpen(event.currentTarget)}>
        Case Summary
      </Button>
    </>
  );
}
